import Model from '@/models/Model.js';

export default class Survey extends Model {
    static entity = 'surveys';

    static modelName = 'Survey';

    static fields() {
        return {
            id: this.attr(null),

            title: this.attr(null),
            questions_per_page: this.attr(null),
            question_count: this.attr(null),
            random_question_order: this.attr(null),
            must_answer_in_order: this.attr(null),
            locked_for_editing: this.attr(null),
            type: this.attr(null),
            original_version_id: this.attr(null),
            calculator_enabled: this.attr(null),
            points_possible: this.attr(null),
            quiz_attempt_count: this.attr(null),
            latest_quiz_attempt: this.attr(null),
            version_number: this.attr(null),
            has_quiz_attempt: this.attr(null),
            published_at: this.attr(null),

            // Relationships...
            // questions,
            // quizAttemptQuestions,
            // quizGroups,
            // groups,
            // attempts,
            // activities,
            // surveyActivityes,
            // automatedSurveyAssignments,
            // activityTemplates,
            // questionsByDisplayOrder,
            // highestDisplayOrder,
            // answers,
            // courseCodes,
            // statuses,
            // tags,
            // version,
        };
    }
}
